export const FIELD_CLASS = "w-full mt-1.5 bg-[var(--bg-main)] border border-[var(--border-default)] px-3 py-2 text-white focus:border-[var(--brand-primary)] outline-none";
export const LABEL_CLASS = "text-xs font-mono uppercase tracking-widest text-white/60";
